package kz.dentalcrm.app.screens.ui

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Round
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

object Icons {
    private var _chevronRight: ImageVector? = null

    val chevronRight: ImageVector
        get() {
            if (_chevronRight != null) {
                return _chevronRight!!
            }
            _chevronRight = Builder(
                name = "ChevronRight", defaultWidth = 24.0.dp, defaultHeight =
                    24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f
            ).apply {
                path(
                    fill = SolidColor(Color(0x00000000)), stroke = SolidColor(Color(0xFF000000)),
                    strokeLineWidth = 2.0f, strokeLineCap = Round, strokeLineJoin =
                        StrokeJoin.Companion.Round, strokeLineMiter = 4.0f, pathFillType = NonZero
                ) {
                    moveTo(9.0f, 18.0f)
                    lineToRelative(6.0f, -6.0f)
                    lineToRelative(-6.0f, -6.0f)
                }
            }
                .build()
            return _chevronRight!!
        }
}